export enum Intergrip1ConnectionsPermissions {
  ProNexus = 'pro-nexus',
}
